/**
 * Per-session UI state.
 *
 * sessionStorage, deliberately — not IndexedDB and not localStorage. The one
 * thing recorded here is "has this session already picked a fair", and
 * sessionStorage's lifetime is exactly right for it: it dies with the tab and
 * with the PWA window, so the answer resets on every fresh launch with nothing
 * to clear, expire or migrate. Putting it in the database would make the choice
 * permanent, which is the behaviour this exists to undo.
 */

const ENTERED_KEY = 'ft.enteredFair';

/**
 * Has the buyer chosen a fair since this session started?
 *
 * Returns TRUE when sessionStorage is unreadable, which is the safe direction:
 * the fairs hub is shown when this is false, and the hub is also the only
 * place that can set it. If reads fail we would bounce someone back to the hub
 * every time they picked a fair — an actual loop. Degrading to "go straight to
 * the dashboard" is the old behaviour, which is merely not the improvement.
 */
export function hasEnteredFair() {
  try {
    return sessionStorage.getItem(ENTERED_KEY) === '1';
  } catch (e) {
    return true;
  }
}

/** Called when a fair is opened — from the hub, or on finishing first-run. */
export function markEnteredFair() {
  try {
    sessionStorage.setItem(ENTERED_KEY, '1');
  } catch (e) {
    /* See hasEnteredFair: a failed write degrades, it does not trap. */
  }
}
